var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImageLine(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_2",
    "data-name": "Camada 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 945.68 945.68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #55565c;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_1-2",
    "data-name": "Camada 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M263.61,729.63c-12.84,0-23.98-4.71-33.41-14.14-9.43-9.43-14.14-20.57-14.14-33.41v-418.47c0-12.84,4.71-23.98,14.14-33.41,9.43-9.43,20.57-14.14,33.41-14.14h418.47c12.84,0,23.98,4.71,33.41,14.14,9.43,9.43,14.14,20.57,14.14,33.41v418.47c0,12.84-4.71,23.98-14.14,33.41-9.43,9.43-20.57,14.14-33.41,14.14h-418.47ZM263.61,682.07h418.47v-418.47h-418.47s0,418.47,0,418.47ZM299.74,616.93h346.67l-105.57-140.76-91.3,119.36-65.62-88.93s-84.17,110.33-84.17,110.33ZM263.61,682.07v-418.47s0,418.47,0,418.47ZM373.03,411.02c10.58,0,19.56-3.7,26.93-11.11,7.37-7.4,11.06-16.4,11.06-26.98,0-10.58-3.7-19.56-11.11-26.93-7.4-7.37-16.4-11.06-26.98-11.06s-19.56,3.7-26.93,11.11c-7.37,7.4-11.06,16.4-11.06,26.98s3.7,19.56,11.11,26.93c7.4,7.37,16.4,11.06,26.98,11.06Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 858.11,
    width: 945.68,
    height: 87.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 214.52,
    width: 175.79,
    height: 87.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 643.59,
    width: 175.79,
    height: 87.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 429.06,
    width: 175.79,
    height: 87.55
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 769.89,
    y: 429.06,
    width: 175.79,
    height: 87.55
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 769.89,
    y: 643.59,
    width: 175.79,
    height: 87.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 945.68,
    height: 87.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 769.89,
    y: 214.52,
    width: 175.79,
    height: 87.57
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageLine);
export default __webpack_public_path__ + "static/media/Image_Line.85f3fb96f3f1af83ad4988c75013c53b.svg";
export { ForwardRef as ReactComponent };